import { createContext } from 'react';
import { defaultPageLayoutProps } from './constants';
export const PageLayoutPropsContext = /*#__PURE__*/createContext(defaultPageLayoutProps);